import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';

import { translate } from '@portal/services/i18n';

import { sendEvent } from '@portal/services/firebase';
import { PageClass } from '@portal/enum/analytics';
import Escrow from './Escrow/Escrow';
import Limits from './Escrow/Limits/Limits';

const ProductsNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.PAYSLIP,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Switch>
      <Route exact path={getRouteStackPath('PRODUCTS', 'PRODUCT_ESCROW')}>
        <PanelContent pageTitle={translate('PAGES.PRODUCTS.ESCROW.TITLE')}>
          <Escrow />
        </PanelContent>
      </Route>
      <Route
        exact
        path={getRouteStackPath('PRODUCTS', 'LIMITS_ESCROW_OPERATIONAL')}
      >
        <PanelContent
          pageTitle={translate('PAGES.PRODUCTS.ESCROW.LIMITS.TITLE')}
        >
          <Limits />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default ProductsNavigationStack;
